import { Box, styled } from '@mui/material';
import offlineImage from '/assets/image/offline.svg';
import { StateCard } from '~/components/Global/Card';
import { SiteFooter } from '~/components/Global/SiteFooter';

const Container = styled(Box)(() => ({
  width: '100%',
  minHeight: 'calc(100vh - 128px)',
  display: 'flex',
  flexDirection: 'column',
  // 不用 center：頁尾要能撐滿整列寬度，置中交給下面的 Content
  alignItems: 'stretch',
}));

// 佔滿扣掉頁尾後的剩餘高度，插圖仍維持置中
const Content = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

type OfflineStateProps = {
  /**
   * 是否顯示站台頁尾。取得資源頁的設計稿在離線狀態下仍保留頁尾，
   * 下載紀錄頁線上本來就沒有頁尾，所以預設不顯示。
   */
  withFooter?: boolean;
};

export const OfflineState = ({ withFooter = false }: OfflineStateProps) => {
  return (
    <Container>
      <Content>
        <StateCard
          imgSrc={offlineImage}
          title="網路連線異常"
          content="恢復連線後即可使用完整功能"
        />
      </Content>
      {withFooter && <SiteFooter />}
    </Container>
  );
};
